// Block Kit wire contract — mirror of the SDK's resolved BlockNode envelope.
// The bot sends a FULLY-RESOLVED tree (bindings substituted, repeats expanded)
// over the `ringg.blocks` text stream; interactions go back over the
// `receive_dynamic_data` RPC as `receive_component_blocks`.
// Spec: GET /tools/v1/blocks-catalog · docs: blockkit-agents-cdn-integration.md

export type BlockValue = string | number | boolean | string[];

export interface BlockAction {
  action: "respond" | "open_url" | "dom_event" | string;
  action_id?: string;
  value?: unknown;
  url?: string;
  target?: "_blank" | "_self";
  event_name?: string;
}

export interface VisibleIf {
  field?: string;
  op?: "eq" | "ne" | "in" | "gt" | "lt" | "truthy";
  value?: unknown;
  all?: VisibleIf[];
  any?: VisibleIf[];
}

export interface BlockNode {
  type: string;
  id?: string;
  name?: string;
  slot?: string;
  props?: Record<string, unknown>;
  children?: BlockNode[];
  visible_if?: VisibleIf;
  on?: Record<string, BlockAction>;
  /** Authored-envelope only (builder): server binding, resolved away at call time. */
  visible?: string | boolean;
  /** Authored-envelope only (builder): repeat expansion, resolved away at call time. */
  repeat?: { source: string; as: string; max_items?: number };
}

export interface BlocksConfig {
  tool_id?: string;
  schema_version?: number;
  blocks: BlockNode[];
}

export interface BlocksActionPayload {
  action_id: string;
  value?: unknown;
  values: Record<string, BlockValue>;
  // The tapped button's label — shown as the user's right-aligned chat bubble,
  // like a quick-reply selection. Not sent to the bot.
  label?: string;
}

// Envelope of one `ringg.blocks` stream message
export interface BlocksStreamMessage {
  component_type: "render_component_blocks";
  component_config: BlocksConfig;
}

// The envelope/wire version this renderer supports; higher versions render a
// graceful fallback instead of failing (§12 of the integration guide).
export const SUPPORTED_BLOCKS_SCHEMA_VERSION = 1;
